import Head from 'next/head'
import * as React from 'react'

import { Button } from '@/components/ui/button'

import { EDUNODES_COMMUNITY_FAVICON_URL, EDUNODES_HOME_URL } from '@/constant/edunodes'

interface CommunityNotFoundPageProps {
  subdomain?: string | null
}

export default function CommunityNotFoundPage({ subdomain }: CommunityNotFoundPageProps) {
  const label = subdomain?.trim() || 'this subdomain'

  return (
    <div className="theme-non-fsds">
      <Head>
        <title>Community not found</title>
        <meta name="description" content="This community does not exist or is no longer available." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="icon" href={EDUNODES_COMMUNITY_FAVICON_URL} type="image/svg+xml" />
        <link rel="shortcut icon" href={EDUNODES_COMMUNITY_FAVICON_URL} type="image/svg+xml" />
        <link rel="apple-touch-icon" href={EDUNODES_COMMUNITY_FAVICON_URL} />
      </Head>
      <div className="container mx-auto flex min-h-[50vh] flex-col items-center justify-center px-4 py-16 text-center">
        <h1 className="text-3xl font-bold tracking-tight text-foreground md:text-4xl">
          Community not found
        </h1>
        <p className="mt-3 max-w-md text-muted-foreground">
          No community is registered for <span className="font-medium text-foreground">{label}</span>.
          It may have been removed, or the address may be incorrect.
        </p>
        <Button asChild className="mt-8">
          <a href={EDUNODES_HOME_URL}>Go to Edunodes</a>
        </Button>
      </div>
    </div>
  )
}
